"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var percentDecrease = function percentDecrease(price, special) {
  var discountPercent = (price - special) / price * 100;
  if (discountPercent > 0 && discountPercent <= 1) {
    return 1;
  }
  return Math.floor(discountPercent);
};
var _default = percentDecrease;
exports["default"] = _default;